module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "priceTotalHolder row"
  }, [(_vm.reservation.billing) ? _c('div', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "col-sm-12 bg-lighter py-2 border-bottom-light"
  }, [_c('div', {
    staticClass: "darkest fs-small d-flex justify-content-between"
  }, [_c('span', [_vm._v("Ticket Price")]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.totalProductGrossprice)) + " €")])]), _vm._v(" "), _c('div', {
    staticClass: "darkest fs-small d-flex justify-content-between border-bottom-light pb-1 mb-1"
  }, [_c('span', [_vm._v("Extras")]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', {
    staticClass: "w-25 text-right"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.totalComponentGrossprice)) + " €")])]), _vm._v(" "), (!_vm.reservation.attachPromocode) ? _c('div', {
    staticClass: "dark fs-small d-flex justify-content-between align-items-center align-items-center"
  }, [_c('span', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v("Discount\n\n                    "), (!_vm.editingDiscount) ? _c('span', {
    staticClass: "px-1"
  }, [_vm._v(_vm._s(_vm.reservation.attachDiscount.value) + _vm._s((_vm.reservation.attachDiscount.valueType == 1) ? '%' : '€'))]) : _vm._e(), _vm._v(" "), (_vm.editingDiscount) ? _c('span', {
    staticClass: "d-flex px-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.attachDiscount.value),
      expression: "reservation.attachDiscount.value"
    }],
    staticClass: "glued-right px-2 py-0 text-center border-medium",
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "number",
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.reservation.attachDiscount.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.attachDiscount, "value", $event.target.value)
      }, _vm.overrideDiscountChanged],
      "focus": _vm.discountInputFocus
    }
  }), _vm._v(" "), (_vm.reservation.attachDiscount.valueType == 1) ? _c('div', {
    staticClass: "glued-left w-25 py-0 px-1 pointer dark border-medium",
    staticStyle: {
      "width": "auto !important"
    },
    on: {
      "click": _vm.switchDiscountType
    }
  }, [_vm._v("%")]) : _vm._e(), _vm._v(" "), (_vm.reservation.attachDiscount.valueType == 0) ? _c('div', {
    staticClass: "glued-left w-25 py-0 px-1 pointer dark border-medium",
    staticStyle: {
      "width": "auto !important"
    },
    on: {
      "click": _vm.switchDiscountType
    }
  }, [_vm._v("€")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editingDiscount) ? _c('button', {
    staticClass: "btn secondary tiny mr-1",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.applyingCustomDiscount
    }
  }, [_vm._v("Apply")]) : _vm._e(), _vm._v(" "), (!_vm.isReservationReadOnly || _vm.reservation.status == 5) ? _c('button', {
    staticClass: "btn secondary tiny ml-1",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.editingDiscountToogle
    }
  }, [_vm._v(_vm._s((_vm.editingDiscount) ? 'Remove' : 'EDIT'))]) : _vm._e()]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.totalDiscounts)) + " €")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "darkest fs-small d-flex justify-content-between border-bottom-light pb-1 mb-1"
  }, [_c('span', [_vm._v("Refunds")]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', {
    staticClass: "w-25 text-right"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.totalRefunds)) + " €")])]), _vm._v(" "), _c('div', {
    staticClass: "darkest fs-small d-flex justify-content-between align-items-center align-items-center"
  }, [_c('span', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', [_vm._v("Commission (total)")]), _vm._v(" "), (_vm.reservation.attachPromocodeType == 1) ? _c('span', {
    staticClass: "bold ml-2"
  }, [_vm._v(_vm._s(_vm.reservation.attachPromocode) + " " + _vm._s(_vm.reservation.attachCommission.productValue) + _vm._s((_vm.reservation.attachDiscount.valueType == 1) ? '%' : '€'))]) : _vm._e()]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.grandTotalCommission)) + " €")])]), _vm._v(" "), _vm._l((_vm.comissionTypes), function(commissionType) {
    return (commissionType.active) ? _c('div', {
      staticClass: "dark fs-small d-flex justify-content-between align-items-center align-items-center"
    }, [_c('span', {
      staticClass: "d-flex align-items-center ml-2"
    }, [_vm._v(_vm._s(commissionType.label) + "\n                        "), _vm._v(" "), (!_vm.isEditingCommissions[commissionType.type.toLowerCase()]) ? _c('span', {
      staticClass: "px-1"
    }) : _c('span', {
      staticClass: "d-flex px-1 align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.reservation.attachCommission[commissionType.type.toLowerCase() + 'Value']),
        expression: "reservation.attachCommission[commissionType.type.toLowerCase()+'Value']"
      }],
      staticClass: "glued-right px-2 py-0 text-center border-medium",
      staticStyle: {
        "width": "40px"
      },
      attrs: {
        "disabled": _vm.disabled,
        "type": "number",
        "placeholder": "0"
      },
      domProps: {
        "value": (_vm.reservation.attachCommission[commissionType.type.toLowerCase() + 'Value'])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.reservation.attachCommission, commissionType.type.toLowerCase() + 'Value', $event.target.value)
        }, function($event) {
          _vm.overrideCommissionChanged($event, commissionType.type.toLowerCase())
        }]
      }
    }), _vm._v(" "), (!_vm.reservation.attachCommission || _vm.reservation.attachCommission[commissionType.type.toLowerCase() + 'ValueType'] == 1) ? _c('div', {
      staticClass: "glued-left w-25 py-0 px-1 pointer dark border-medium",
      staticStyle: {
        "width": "auto !important"
      },
      on: {
        "click": function($event) {
          return _vm.switchCommissionType(commissionType.type)
        }
      }
    }, [_vm._v("%")]) : _vm._e(), _vm._v(" "), (_vm.reservation.attachCommission && _vm.reservation.attachCommission[commissionType.type.toLowerCase() + 'ValueType'] == 0) ? _c('div', {
      staticClass: "glued-left w-25 py-0 px-1 pointer dark border-medium",
      staticStyle: {
        "width": "auto !important"
      },
      on: {
        "click": function($event) {
          return _vm.switchCommissionType(commissionType.type)
        }
      }
    }, [_vm._v("€")]) : _vm._e(), _vm._v(" "), (_vm.reservation.attachCommission['isToOverwrite' + commissionType.type]) ? _c('button', {
      staticClass: "btn secondary tiny mx-1",
      attrs: {
        "disabled": _vm.disabled
      },
      on: {
        "click": function($event) {
          return _vm.updateCommissions(commissionType)
        }
      }
    }, [_vm._v("Apply")]) : _vm._e()]), _vm._v(" "), (commissionType.editable && (!_vm.isReservationReadOnly || _vm.reservation.status == 5)) ? _c('button', {
      staticClass: "btn secondary tiny",
      attrs: {
        "disabled": _vm.disabled
      },
      on: {
        "click": function($event) {
          return _vm.editingCommissionToogle(commissionType.type)
        }
      }
    }, [_vm._v(_vm._s((_vm.isEditingCommissions[commissionType.type.toLowerCase()]) ? 'Use default' : 'EDIT'))]) : _vm._e()]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
      attrs: {
        "size": "small",
        "opacity": "0.2"
      }
    })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations['total' + commissionType.type + 'CommissionToEntityGrossprice'])) + " €")])]) : _vm._e()
  }), _vm._v(" "), (_vm.reservation.attachPromocode && _vm.reservation.attachPromocodeType == 0) ? _c('div', {
    staticClass: "fs-small d-flex justify-content-between align-items-center align-items-center"
  }, [_c('span', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v("Promocode: "), _c('span', {
    staticClass: "bold ml-1"
  }, [_vm._v(_vm._s(_vm.reservation.attachPromocode))]), _vm._v(" "), _c('span', {
    staticClass: "px-1 bold"
  }, [_vm._v(_vm._s(_vm.reservation.attachDiscount.value) + _vm._s((_vm.reservation.attachDiscount.valueType == 1) ? '%' : '€'))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.totalDiscounts)) + " €")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "darkest fs-large font-weight-600 d-flex justify-content-between border-top-light mt-1"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "big",
      "opacity": "0.2"
    }
  })], 1) : _c('span', {
    staticClass: "pl-4"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.grandTotal)) + " €")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 bg-darker radius-bottom-right-normal radius-bottom-left-normal areaTotal align-items-center d-flex flex-row"
  }, [(_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "big",
      "opacity": "0.2"
    }
  })], 1) : (_vm.reservation.status != '-5') ? _c('div', {
    staticClass: "lightest fs-giant font-weight-600 d-flex justify-content-between align-items-center w-100 py-1"
  }, [(_vm.roundPriceValue(_vm.totalDue) > 0) ? _c('span', {
    staticClass: "lightest bg-color-6 px-2 py-1 fs-normal radius-normal text-uppercase",
    class: 'bg-' + _vm.getPaymentState(0).color
  }, [_vm._v(_vm._s(_vm.getPaymentState(0).label))]) : _vm._e(), _vm._v(" "), (_vm.roundPriceValue(_vm.totalDue) == 0) ? _c('span', {
    staticClass: "lightest bg-color-3 px-2 py-1 fs-normal radius-normal text-uppercase",
    class: 'bg-' + _vm.getPaymentState(1).color
  }, [_vm._v(_vm._s(_vm.getPaymentState(1).label))]) : _vm._e(), _vm._v(" "), (_vm.roundPriceValue(_vm.totalDue) < 0) ? _c('span', {
    staticClass: "lightest bg-color-5 px-2 py-1 fs-normal radius-normal text-uppercase",
    class: 'bg-' + _vm.getPaymentState(2).color
  }, [_vm._v(_vm._s(_vm.getPaymentState(2).label))]) : _vm._e(), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "big",
      "opacity": "0.2"
    }
  })], 1) : (_vm.totalDue != 0) ? _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.totalDue)) + "€")]) : _vm._e()]) : (_vm.reservation.status == '-5') ? _c('div', {
    staticClass: "lightest fs-giant font-weight-600 d-flex justify-content-between align-items-center w-100 py-1"
  }, [(_vm.roundPriceValue(_vm.refundTotalMissing) > 0) ? _c('span', {
    staticClass: "lightest px-2 py-1 fs-normal radius-normal text-uppercase",
    class: 'bg-' + _vm.getPaymentState(2).color
  }, [_vm._v(_vm._s(_vm.getPaymentState(2).label))]) : _vm._e(), _vm._v(" "), (_vm.roundPriceValue(_vm.refundTotalMissing) == 0) ? _c('span', {
    staticClass: "lightest px-2 py-1 fs-normal radius-normal text-uppercase",
    class: 'bg-' + _vm.getPaymentState(4).color
  }, [_vm._v(_vm._s(_vm.getPaymentState(4).label))]) : _vm._e(), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "big"
    }
  })], 1) : (_vm.refundTotalMissing != 0) ? _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.refundTotalMissing * -1)) + "€")]) : _vm._e()]) : _vm._e()])]) : _c('div', {
    staticClass: "dark text-center m-3 w-100"
  }, [_c('div', {
    staticClass: "fs-large darker"
  }, [_vm._v("Unable to load information")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-b5289d6a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5289d6a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEdit/TabDetails/PriceTotal.vue
// module id = 1759
// module chunks = 0